export const en = {
    "en": "English",
    "zh": "中文",
    "Language": "Language",
    "Text": "Text",
    "RequiredFormat": "Please enter {0}",
    "I18nRequiredFormat": "Please enter {0} {1}"
}